/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReviewImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ReviewImage({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Review/ReviewImage"
  
}) {
  let isMedia = useIsMedia()
let imagePreviewValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'preview',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<img
  data-testid="ReviewImage.Image"
  data-view-path={viewPath}
 alt={""}
 src={imagePreviewValueData}
 style={{'--mr-1-Z1w09WJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-2-Z1w09WJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-Z1w09WJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-Z1w09WJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-Z1w09WJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-Z1w09WJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mh-7-Z1w09WJ': isMedia.mobile ? "100px" : "140px"}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}